import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { BRAKE_VC_LOGS_MONITORING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { BRAKE_VC_LOGS_MONITORING_REPORT } from "../interfaces/dashboard";

export default function BrakeVCLogsMonitoring() {
    const brakeVCLogsMonitoringReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.BRAKE_VC_LOGS_MONITORING_REPORT;

    const [brakeVCLogsMonitoringReportTableData, setBrakeVCLogsMonitoringReportTableData] = useState<BRAKE_VC_LOGS_MONITORING_REPORT[]>([]);

    useEffect(() => {
        setBrakeVCLogsMonitoringReportTableData(BRAKE_VC_LOGS_MONITORING_REPORT_DATA)
    }, []);

    return (
        <Reports
            reportType="BRAKE_VC_LOGS_MONITORING"
            tableColumns={brakeVCLogsMonitoringReportTableColumns}
            tableData={brakeVCLogsMonitoringReportTableData} />
    );
}